import { ArticlesForAutocompleteQuery } from './__generated__/ArticlesForAutocompleteQuery';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { ARTICLES_FOR_AUTOCOMPLETE_QUERY } from './articlesForAutocomplete.query';

export const useArticlesForAutocompleteQuery = () => {
  return useLazyQuery<ArticlesForAutocompleteQuery>(ARTICLES_FOR_AUTOCOMPLETE_QUERY, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
